// Vectis ürün kataloğu — tüm sayfalar bu dosyayı kullanır.
// Stüdyo fotoğrafları: img/products/<slug>/1-on.jpg, 2-aci.jpg, 3-yan.jpg, 4-detay.jpg, 5-ust.jpg
// Dosya yoksa ürünün mevcut render'ı (img) gösterilir.
// price = lansman fiyatı, compare = normal fiyat (üstü çizili). İndirim yüzdesi otomatik hesaplanır.

const ANGLES = [["1-on", "Ön"], ["2-aci", "Açılı"], ["3-yan", "Yan profil"], ["4-detay", "Detay"], ["5-ust", "Üstten"]];

const SPECS = {            // Aegean Series ortak teknik özellikler (vectispadel.com'dan)
  "Yüzey": "%100 Japon 3K Karbon · Mat",
  "Doku": "3D Sand-Grit",
  "Çekirdek": "HR3 Black EVA Soft",
  "Çerçeve": "Aerospeed Frame",
  "Kalınlık": "38 mm",
  "Form": "Hibrit damla (turnuva kalıbı)",
  "Ağırlık": "360 g",
  "Denge": "Orta",
};

const TECH = [
  { t: "Japon 3K Karbon", d: "%100 Japon 3K karbon elyaf, ham mat yüzey. Yüksek dayanım ve dengeli esneklik; her vuruşta tutarlı tepki.", img: "1-on" },
  { t: "3D Sand-Grit", d: "Mikro zımpara dokulu yüzey: agresif falso, yüksek spin ve üstün top tutuşu.", img: "4-detay" },
  { t: "HR3 Black EVA Soft", d: "Titreşimi sönümleyen, eklem dostu turnuva çekirdeği. Konforlu vuruş hissi ve geniş tatlı nokta.", img: "2-aci" },
  { t: "Aerospeed Frame", d: "Hava direncini azaltan aerodinamik 38 mm çerçeve ile daha hızlı swing; hibrit damla kalıp.", img: "3-yan" },
];

const PRODUCTS = [   // sitedeki sıra; edition: true → Özel Seri olarak ayrı tanıtılır
  { slug: "titanium-silver", name: "Titanium Silver", c: "#c9cdd2", tag: "Lansman", img: ASSET["hero"],
    line: "Mat 3K karbon, fırçalanmış titanyum gümüş vurgular. Saf performans.",
    desc: "Titanium Silver, serinin en saf versiyonu. Mat Japon 3K karbon yüzey üzerinde fırçalanmış titanyum gümüş V amblem; teknik ve sade görünümü sevenler için.",
    price: 8690, compare: 11690 },
  { slug: "desert-gold", name: "Desert Gold", c: "#d4b27a", tag: "Lansman", img: ASSET["gold"],
    line: "Sessiz lüks. Fırçalanmış altın V, mat siyah karakter.",
    desc: "Desert Gold, serinin en iddialı yüzü. Fırçalanmış şampanya altını V amblem ve mat siyah gövde; kortta da, kulüp vitrininde de premium bir duruş.",
    price: 8690, compare: 11690 },
  { slug: "cyber-violet", name: "Cyber Violet", c: "#e04fc8", tag: "Lansman", img: ASSET["violet"],
    line: "Enerji yüksek. Mat 3K karbonda elektrik moru vurgular.",
    desc: "Cyber Violet, cesur oyuncular için. Kumlu dokulu siyah yüzey ve neon pembe-mor vurgular; kortta dikkat çekmekten çekinmeyenlerin raketi.",
    price: 8690, compare: 11690 },
  { slug: "aegean-teal", name: "Aegean Teal", c: "#3fd0c9", tag: "Lansman", img: ASSET["teal"],
    line: "Ege'nin rengi, kortun ritmi. Mat siyah gövdede turkuaz V.",
    desc: "Aegean Teal, serinin adını taşıyan renk. Mat siyah yüzey ve çerçeve üzerinde Ege denizinden ilham alan turkuaz vurgu; kortta ilk bakışta tanınan bir siluet.",
    price: 8690, compare: 11690 },
  { slug: "shadow-edition", name: "Shadow Edition", c: "#e6e6e6", tag: "Special Edition", edition: true, img: ASSET["shadow"],
    line: "Serinin ters yüzü. Fırçalanmış gümüş gövde, siyah V, beyaz grip.",
    desc: "Shadow Edition, Aegean Series'in özel sürümü. Dört ana rengin siyah gövdesini tersine çevirdik: fırçalanmış gümüş görünümlü yüzey ve çerçeve, derin siyah V amblem ve beyaz grip. Aynı turnuva mühendisliği, koleksiyondaki en minimal ve en dikkat çekici duruş.",
    price: 12690 },
];

// Ürün videosu (onaylı 1-on fotoğrafından kodla: ışık geçişi + hafif yalpalama; logo/yazı birebir). Poster = ilk kare.
PRODUCTS.forEach(p => { p.video = ASSET[`${p.slug}-video`]; p.poster = ASSET[`${p.slug}-poster`]; });
// Reklam filmleri (16:9, sesli)
const FILMS = {
  shadow: { src: ASSET["film-shadow"], poster: ASSET["film-shadow-poster"] },
  seri: { src: ASSET["film-seri"], poster: ASSET["film-seri-poster"] },
};
// Sessiz başlayan videoya ses aç/kapa düğmesi
function sesDugmesi(video, kap) {
  const b = document.createElement("button");
  b.className = "ses"; b.type = "button"; b.textContent = "Sesi aç";
  b.onclick = () => { video.muted = !video.muted; if (!video.muted) video.play(); b.textContent = video.muted ? "Sesi aç" : "Sesi kapat"; };
  kap.appendChild(b);
}

const shot = (p, a) => ASSET[`${p.slug}-${a}`];
const cut = p => ASSET[`${p.slug}-360`];   // şeffaf raket kesimi (ana sayfa karuseli)
// <img> etiketi: stüdyo fotoğrafı yoksa render'a düşer
const studioImg = (p, a, cls = "") =>
  `<img class="${cls}" src="${shot(p, a)}" alt="Vectis ${p.name} — ${(ANGLES.find(x => x[0] === a) || [, ""])[1]}" loading="lazy" onerror="this.onerror=null;this.src='${p.img}';this.classList.add('fallback')">`;
const CORE = PRODUCTS.filter(p => !p.edition), EDITION = PRODUCTS.filter(p => p.edition);
const tl = n => n.toLocaleString("tr-TR") + " TL";
const priceText = p => p.price ? (p.compare ? `<s style="color:var(--mute);margin-right:6px">${tl(p.compare)}</s>${tl(p.price)}` : tl(p.price)) : "Yakında";
const discount = p => p.compare ? Math.round((1 - p.price / p.compare) * 100) : 0;
const priceHTML = p => p.price
  ? `<span class="pl">${p.compare ? "Lansman fiyatı" : "Special Edition"}</span>${tl(p.price)}${p.compare
      ? ` <s>${tl(p.compare)}</s> <span class="off">%${discount(p)} indirim</span>` : ""}`
  : "Yakında";
